import type { KioskUser, Nullish, User } from '@iheartjane/types';

export const getUsername = (kioskUser: Nullish<User | KioskUser>) => {
  if (!kioskUser) {
    return null;
  }

  const { first_name, last_name, email } = kioskUser;

  let userName = '';

  if (first_name) {
    userName = `${first_name}${last_name ? ` ${last_name}` : ''}`;
  } else {
    userName = email;
  }

  return userName;
};
